import React from 'react';
import './QuestionNumber.scss';

const QuestionNumber = props => {
  return (
    <div className='QuestionNumber'>
      <span className='current'>{props.current}</span>/<span className="total">{props.total}</span>
    </div>
  );
};

export default QuestionNumber;
